import { Stack, Typography } from '@mui/material'
import { TruckVisitWithOrdersDto } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, HighlightedText, useMinimalsTheme, UsersIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface Props {
  truckVisit: TruckVisitWithOrdersDto
  isSearch?: boolean
  highlight?: string
}
export const TruckVisitDriver = observer(({ truckVisit, isSearch, highlight }: Props) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  if (!truckVisit.driver?.driverID) return <></>

  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      <UsersIcon />
      {isSearch ? (
        <Stack direction='row' alignItems='center' gap={1}>
          <Typography variant='subtitle1'>
            <HighlightedText highlight={highlight} color={theme.palette.info.main}>
              {truckVisit.driver.driverID}
            </HighlightedText>
          </Typography>
          {truckVisit.driver.banned && (
            <ColoredLabel color='warning' label={t('banned', 'Banned')} />
          )}
        </Stack>
      ) : (
        <Stack>
          <Stack direction='row' alignItems='center' gap={1}>
            <Typography variant='body2'>{truckVisit.driver.name}</Typography>
            {truckVisit.driver.banned && (
              <ColoredLabel color='warning' label={t('banned', 'Banned')} />
            )}
          </Stack>
          <Typography variant='caption' color='secondary'>
            {truckVisit.driver.driverID}
          </Typography>
        </Stack>
      )}
    </Stack>
  )
})
